import styled from 'styled-components';

export default function CustomInput(props) {
  const { value, setValue, placeholder, width, disabled, disabled2, disabled3, textAlign, onlyNumber, onFocus, onBlur, flexShrink = false, isWarning = false } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    if (onlyNumber) {
      setValue(e.target.value.replace(/[^0-9]/g, ''));
    }
    else {
      setValue(e.target.value);
    }
  }

  function handleFocus(e) {
    if (onFocus) onFocus(e);
  }

  function handleBlur(e) {
    if (onBlur) onBlur(e);
  }

  return (
    <Input $disabled={disabled}
      $disabled2={disabled2}
      $disabled3={disabled3}
      type='text'
      disabled={disabled || disabled2 || disabled3}
      placeholder={placeholder}
      value={value}
      textAlign={textAlign}
      width={width}
      $flexShrink={flexShrink}
      $isWarning={isWarning}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
  )
}

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	box-sizing: border-box;
	width: ${props => props.width ? `${props.width}px` : undefined};
  flex: ${props => props.width ? undefined : 1};
  min-width: ${props => props.$flexShrink ? '0' : undefined};
	height: 32px;

	padding: 0 10px;

	outline: none;
	border: 1px solid ${props => props.$disabled ? props.theme.background : props.theme.line};
	border-radius: 5px;
	color: ${props => props.$isWarning ? props.theme.pointRed : props.theme.text};
	background-color: ${props => props.theme.subBackground};

  text-align: ${props => props.textAlign};
  pointer-events: ${props => props.$disabled ? 'none' : 'auto'};
  cursor: ${props => (props.$disabled || props.$disabled2 || props.$disabled3) ? 'not-allowed' : 'pointer'};
	opacity: ${props => props.$disabled ? 0.4 : 1};

  background-color: ${props => props.$disabled3 ? props.theme.subBackground : props.$disabled2 ? props.theme.buttonFill : props.theme.subBackground};
  border-color: ${props => props.$isWarning ? props.theme.pointRed : props.$disabled3 ? props.theme.subBackground : props.$disabled2 ? props.theme.buttonFill : props.theme.line};

  transition: all 0.3s ease-in-out;
`;